import cognitoAuth from '@/cognito'
import errorReporter from '@/utils/errorReporter'

const USER_API_KEY_REJECTED = 'USER_API_KEY_REJECTED'

export const aiResponseError = (error) => Object.assign(
  new Error(error.message),
  { aiError: true },
  error.status ? { status: error.status } : {},
  error.code === USER_API_KEY_REJECTED ? { userKeyRejected: true } : {}
)

export class HttpError extends Error {
  constructor (message, status, statusText, body = null) {
    super(message)
    this.name = 'HttpError'
    this.status = status
    this.statusText = statusText
    this.body = body
  }
}

export const sendHttpRequest = async (url, method, headers, body, signal) => {
  let response
  try {
    response = await fetch(url, { method, headers, body, signal })

    if (!response.ok) {
      const errorBodyText = await response.text()

      throw new HttpError(
        `HTTP Error: ${response.status} ${response.statusText}`,
        response.status,
        response.statusText,
        errorBodyText
      )
    }

    return response
  } catch (error) {
    if (error instanceof HttpError || error.name === 'AbortError') {
      throw error
    }
    console.error('Network request failed:', error)

    throw new Error('The request could not be completed. Check your connection and try again.')
  }
}

const getIdToken = async (rejectedIdToken) => {
  let jwtToken
  try {
    jwtToken = await cognitoAuth.getIdTokenPromise({ rejectedIdToken })
  } catch (error) {
    jwtToken = null
  }

  if (!jwtToken) {
    throw new Error('User authentication failed. Cannot call AI service.')
  }

  return jwtToken
}

export const sendAuthorizedRequest = async (url, method, headers, body, signal) => {
  const jwtToken = await getIdToken()

  try {
    return await sendHttpRequest(url, method, { ...headers, Authorization: `Bearer ${jwtToken}` }, body, signal)
  } catch (error) {
    if (!(error instanceof HttpError) || error.status !== 401) {
      throw error
    }

    const replacementToken = await getIdToken(jwtToken)
    const response = await sendHttpRequest(url, method, { ...headers, Authorization: `Bearer ${replacementToken}` }, body, signal)
    errorReporter.reportError({ message: 'Refused token replaced', type: 'auth-retry', extra: { operationName: 'chat' } })

    return response
  }
}
